import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=67321cfb&scoped=true"
import script from "./logList.vue?vue&type=script&lang=js"
export * from "./logList.vue?vue&type=script&lang=js"
import style0 from "./logList.vue?vue&type=style&index=0&id=67321cfb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67321cfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67321cfb')) {
      api.createRecord('67321cfb', component.options)
    } else {
      api.reload('67321cfb', component.options)
    }
    module.hot.accept("./logList.vue?vue&type=template&id=67321cfb&scoped=true", function () {
      api.rerender('67321cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clientManagement/logList.vue"
export default component.exports